// The sign-in ticket of each chat, kept in the browser so that the chat starts signed in again.
// The server accepts it only while the user's Keycloak session is open. Inside a cross-site
// iframe, the storage is partitioned by the embedding site, so is the ticket.
const ticketKey = (dochatConfigId: string) => `do-chat.auth-ticket.${dochatConfigId}`;

// The storage may be missing (server rendering) or throw (blocked site data, private browsing):
// the chat then asks for a sign-in at every start.
export function readStoredTicket(dochatConfigId: string): string | null {
  try {
    return window.localStorage.getItem(ticketKey(dochatConfigId));
  } catch {
    return null;
  }
}

export function storeTicket(dochatConfigId: string, ticket: string): void {
  try {
    window.localStorage.setItem(ticketKey(dochatConfigId), ticket);
  } catch {
    // Kept in memory only, for the life of the page.
  }
}

export function forgetStoredTicket(dochatConfigId: string): void {
  try {
    window.localStorage.removeItem(ticketKey(dochatConfigId));
  } catch {
    // Nothing was stored.
  }
}
